/*!
 * Pentomino — motor de calculadoras v1.0 (octubre 2026)
 * Una sola fuente de cálculo para el sitio web y las calculadoras independientes.
 * Lógica replicada de: HBL_Ahorro_Traslado_vs_Reciclaje_Pentomino_sep26.xlsx y
 * Modelo_de_negocio_Pentomino_vs_Traslado_de_Valores_tradicional_sep26.xlsx.
 * Todas las cifras en MXN por mes salvo que se indique.
 */
(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory();
  else root.PentominoCalc = factory();
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  var DEFAULTS = {
    // Red Pentomino — Reporte_operaciones_Pentomino_Jun2025 (22 cajeros: 15,987 retiros, 1,503 consultas)
    retiroPromedio: 2138.38,          // MXN por retiro
    pctConsultas: 1503 / 15987,       // consultas de saldo por cada retiro (9.4%)
    retirosPorCajero: 727,            // retiros por cajero al mes en la red, junio 2025

    // Comisión cobrada al tarjetahabiente (surcharge) — modelo HBL sep26
    comisionRetiro: 35,
    comisionConsulta: 25,
    comisionesIncluyenIVA: true,      // POR CONFIRMAR: el Excel HBL las toma como ingreso neto (sin quitar IVA)
    iva: 0.16,

    // Costo directo por operación, sin IVA — Costo_Transaccional_Pentomino_sin_internacionales_sep_2026
    costoRetiro:   { sponsor: 1.2068965517241399, prosa: 0.280566, intercambio: 1.90 },
    costoConsulta: { sponsor: 0.60344827586206895, prosa: 0.2398, intercambio: 1.54 },

    // Cajero reciclador
    piezasPorCasetero: 1800,
    denominaciones: [500, 200, 100, 50],
    pctLlenadoVisita: 0.80,           // la transportadora va cuando el cajero llega a 80%
    diasAcreditacionCajero: 1,        // reintegro T+1
    visitasMinimasPorCajeroMes: 1,    // piso operativo: al menos una recolección por cajero al mes si hay excedente

    // Transportadora — tarifario 2026 "Servicios de dotación y recolección de valores"
    tarifaServicio: 800,
    cuotaRiesgoMillar: 1.50,
    procesoMillar: 1.20,
    tarifaMismoDia: 1397.5,
    tarifa24h: 1250,
    tarifaMinuto: 13,
    semanasPorMes: 4.33,

    // Costos internos del comercio
    horasPorServicio: 1.5,
    costoHora: 120,
    diasTransito: 2,
    tasaOportunidad: 0.11,
    pctFaltantes: 0.0001,

    // Términos comerciales — POR CONFIRMAR (modelo HBL sep26)
    cuotaMensualPorCajero: 22000,
    pctUtilidadAlComercio: 0.50,

    // Sponsor
    pctUtilidadAlSponsor: 0,          // participación adicional en la utilidad transaccional, si se pacta
    pctExcedenteEnSponsor: 1,         // parte del excedente que la ETV deposita en cuentas del sponsor
    diasPermanenciaFondeo: 15,        // días promedio que el depósito permanece como saldo
    margenFondeoAnual: 0.03           // margen financiero anual estimado sobre ese saldo
  };

  function merge(base, extra) {
    var out = {}, k;
    for (k in base) out[k] = base[k];
    for (k in (extra || {})) if (extra[k] !== undefined && extra[k] !== null && extra[k] !== '') out[k] = extra[k];
    return out;
  }
  function sum(o) { var s = 0; for (var k in o) s += o[k]; return s; }

  /** Utilidad neta por operación para la red (comisión neta − costos directos). */
  function utilidadPorOperacion(p) {
    var div = p.comisionesIncluyenIVA ? (1 + p.iva) : 1;
    var netRet = p.comisionRetiro / div, netCon = p.comisionConsulta / div;
    var cRet = sum(p.costoRetiro), cCon = sum(p.costoConsulta);
    return { comisionNetaRetiro: netRet, comisionNetaConsulta: netCon,
             costoRetiro: cRet, costoConsulta: cCon,
             retiro: netRet - cRet, consulta: netCon - cCon };
  }

  function capacidadCajero(p) {
    var cap = p.piezasPorCasetero * p.denominaciones.reduce(function (a, b) { return a + b; }, 0);
    return { capacidad: cap, umbral: cap * p.pctLlenadoVisita };
  }

  /**
   * Comercio: costo de traslado tradicional vs. cajero reciclador Pentomino.
   * Entrada mínima: sucursales, efectivoMensualPorSucursal, recoleccionesSemana, retirosPorCajero.
   */
  function calcularComercio(input) {
    var p = merge(DEFAULTS, input);
    var sucursales = +p.sucursales || 1;
    var cajeros = sucursales * (+p.cajerosPorSucursal || 1);
    var efectivoMes = p.efectivoMensualTotal != null ? +p.efectivoMensualTotal : sucursales * +p.efectivoMensualPorSucursal;
    var r = { parametros: p, cajeros: cajeros, efectivoMes: efectivoMes };

    // ---- Escenario tradicional ----
    var servT = +p.recoleccionesSemana * p.semanasPorMes * sucursales;
    var montoServT = servT > 0 ? efectivoMes / servT : 0;
    var millT = Math.ceil(montoServT / 1000);
    var T = {
      servicios: servT, montoPorServicio: montoServT,
      transportadora: {
        base: servT * p.tarifaServicio,
        riesgo: millT * servT * p.cuotaRiesgoMillar,
        proceso: millT * servT * p.procesoMillar,
        especiales: (+p.serviciosMismoDia || 0) * p.tarifaMismoDia + (+p.servicios24h || 0) * p.tarifa24h,
        minutos: servT * (+p.minutosExcedentes || 0) * p.tarifaMinuto
      },
      internos: {
        personal: servT * p.horasPorServicio * p.costoHora,
        float: efectivoMes * p.diasTransito / 365 * p.tasaOportunidad,
        faltantes: efectivoMes * p.pctFaltantes
      }
    };
    T.subtotalTransportadora = sum(T.transportadora);
    T.subtotalInternos = sum(T.internos);
    T.total = T.subtotalTransportadora + T.subtotalInternos;

    // ---- Escenario Pentomino ----
    var retiros = +p.retirosPorCajero, consultas = retiros * p.pctConsultas;
    var dispensado = cajeros * retiros * p.retiroPromedio;
    var reciclado = (p.pctReciclajeFijo != null) ? efectivoMes * p.pctReciclajeFijo : Math.min(efectivoMes, dispensado);
    var excedente = Math.max(0, efectivoMes - reciclado);
    var cap = capacidadCajero(p);
    var servP = excedente > 0 ? Math.max(excedente / cap.umbral, p.visitasMinimasPorCajeroMes * cajeros) : 0;
    var montoServP = servP > 0 ? excedente / servP : 0;
    var millP = Math.ceil(montoServP / 1000);
    var u = utilidadPorOperacion(p);
    var P = {
      retirosPorCajero: retiros, consultasPorCajero: consultas,
      dispensado: dispensado, reciclado: reciclado, excedente: excedente,
      pctReciclado: efectivoMes > 0 ? reciclado / efectivoMes : 0,
      servicios: servP, montoPorServicio: montoServP, umbralCajero: cap.umbral,
      transportadora: {
        base: servP * p.tarifaServicio,
        riesgo: millP * servP * p.cuotaRiesgoMillar,
        proceso: millP * servP * p.procesoMillar,
        especiales: (+p.serviciosMismoDiaPentomino || 0) * p.tarifaMismoDia,
        minutos: servP * (+p.minutosExcedentes || 0) * p.tarifaMinuto
      },
      internos: {
        personal: servP * p.horasPorServicio * p.costoHora,
        float: excedente * p.diasTransito / 365 * p.tasaOportunidad + reciclado * p.diasAcreditacionCajero / 365 * p.tasaOportunidad,
        faltantes: excedente * p.pctFaltantes
      },
      utilidad: u,
      cuotas: p.cuotaMensualPorCajero * cajeros,
      participacion: (u.retiro * retiros + u.consulta * consultas) * p.pctUtilidadAlComercio * cajeros
    };
    P.subtotalTransportadora = sum(P.transportadora);
    P.subtotalInternos = sum(P.internos);
    P.servicioNeto = P.cuotas - P.participacion;
    P.total = P.subtotalTransportadora + P.subtotalInternos + P.servicioNeto;

    r.tradicional = T; r.pentomino = P;
    r.ahorroMensual = T.total - P.total;
    r.ahorroAnual = r.ahorroMensual * 12;
    r.pctAhorro = T.total > 0 ? r.ahorroMensual / T.total : 0;
    r.horasLiberadas = (servT - servP) * p.horasPorServicio;
    r.recoleccionesEvitadas = servT - servP;
    return r;
  }

  /** Banco o institución sponsor: ingreso estimado por la red Pentomino. */
  function calcularSponsor(input) {
    var p = merge(DEFAULTS, input);
    var cajeros = +p.cajeros || 1;
    var retirosMes = cajeros * +p.retirosPorCajero;
    var consultasMes = retirosMes * p.pctConsultas;
    var comR = p.comisionSponsorRetiro != null ? +p.comisionSponsorRetiro : p.costoRetiro.sponsor;
    var comC = p.comisionSponsorConsulta != null ? +p.comisionSponsorConsulta : p.costoConsulta.sponsor;
    var u = utilidadPorOperacion(p);
    var utilidadRed = retirosMes * u.retiro + consultasMes * u.consulta;
    var dispensado = retirosMes * p.retiroPromedio;
    var depositado = cajeros * +p.efectivoDepositadoPorCajero;
    var reciclado = Math.min(depositado, dispensado);
    var excedente = Math.max(0, depositado - reciclado);
    var excedenteSponsor = excedente * p.pctExcedenteEnSponsor;
    var saldoPromedio = excedenteSponsor * p.diasPermanenciaFondeo / 30;
    var ingresos = {
      comisionRetiros: retirosMes * comR,
      comisionConsultas: consultasMes * comC,
      participacion: utilidadRed * p.pctUtilidadAlSponsor,
      margenFondeo: saldoPromedio * p.margenFondeoAnual / 12
    };
    var total = sum(ingresos);
    return {
      parametros: p, cajeros: cajeros, retirosMes: retirosMes, consultasMes: consultasMes,
      operacionesMes: retirosMes + consultasMes, liquidadoProsa: reciclado, dispensado: dispensado,
      depositado: depositado, excedente: excedente, excedenteSponsor: excedenteSponsor,
      saldoPromedio: saldoPromedio, utilidadRed: utilidadRed, ingresos: ingresos,
      totalMensual: total, totalAnual: total * 12, porCajero: total / cajeros
    };
  }

  return { DEFAULTS: DEFAULTS, calcularComercio: calcularComercio, calcularSponsor: calcularSponsor,
           utilidadPorOperacion: utilidadPorOperacion, capacidadCajero: capacidadCajero, version: '1.0.0' };
});
